import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { HeartIcon, XIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
const PROMO_END_DATE = new Date('2026-05-12T00:00:00-04:00'); // 11 de mayo 23:59 ET
export function PromoBanner() {
  const [visible, setVisible] = useState(true);
  const [expired, setExpired] = useState(false);
  const {
    t
  } = useLanguage();
  useEffect(() => {
    const checkExpiry = () => {
      if (new Date() >= PROMO_END_DATE) {
        setExpired(true);
      }
    };
    checkExpiry();
    const interval = setInterval(checkExpiry, 60000);
    return () => clearInterval(interval);
  }, []);
  if (expired) return null;
  return <AnimatePresence data-id="element-317">
      {visible && <motion.div initial={{
      height: 0,
      opacity: 0
    }} animate={{
      height: 'auto',
      opacity: 1
    }} exit={{
      height: 0,
      opacity: 0
    }} transition={{
      duration: 0.3,
      ease: 'easeInOut'
    }} className="relative z-[60] overflow-hidden bg-brand-gold" data-id="element-318">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-319">
            <div className="flex items-center justify-center py-2.5 md:py-3 relative" data-id="element-320">
              <div className="flex items-center gap-2 md:gap-3 text-center" data-id="element-321">
                <HeartIcon className="w-4 h-4 text-white/80 hidden sm:block" data-id="element-322" />
                <p className="text-white text-xs md:text-sm font-medium tracking-wide" data-id="element-323">
                  <span className="font-bold text-sm md:text-base" data-id="element-324">
                    {t('promo.discount')}
                  </span>
                  <span className="mx-1.5 text-white/60 hidden sm:inline" data-id="element-325">
                    —
                  </span>
                  <span className="ml-1 sm:ml-0" data-id="element-326">{t('promo.event')}</span>
                </p>
                <span className="text-white/40 mx-2 hidden md:inline" data-id="element-327">|</span>
                <a href="https://wa.me/15513328938?text=Hola%2C%20quiero%20aprovechar%20el%2020%25%20de%20descuento%20por%20el%20D%C3%ADa%20de%20la%20Madre" target="_blank" rel="noopener noreferrer" className="hidden md:inline-flex items-center text-xs font-bold text-white uppercase tracking-widest hover:text-white/80 transition-colors underline underline-offset-2" data-id="element-328">
                  {t('promo.book')}
                </a>
              </div>

              <button onClick={() => setVisible(false)} className="absolute right-0 top-1/2 -translate-y-1/2 p-1.5 text-white/60 hover:text-white transition-colors" aria-label="Cerrar banner" data-id="element-329">
                <XIcon className="w-3.5 h-3.5" data-id="element-330" />
              </button>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}